/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class NodeKey extends cc.Component
{
    @property({ readonly: true })
    protected key: string = '';
    public get Key(): string { return this.key; }
    public set Key(value: string) { this.key = value; }

    /** @hidden */
    protected onLoad(): void
    {
        if (!this.key)
        {
            this.resetKey();
        }
    }

    /** @hideen */
    protected resetInEditor(): void
    {
        this.resetKey();
    }

    private resetKey(): void
    {
        this.key = Math.random().toString(36).substr(2, 10);
    }

    public static HasSameKey(nodeA: cc.Node, nodeB: cc.Node): boolean
    {
        let nodeAKey: NodeKey = nodeA.getComponent(NodeKey);
        if (!nodeAKey) { return false; }

        let nodeBKey: NodeKey = nodeB.getComponent(NodeKey);
        if (!nodeBKey) { return false; }

        return nodeAKey.Key === nodeBKey.Key;
    }
}
